import Content from '../../../../components/Section/Content';
import Box from '../../../../components/Section/Box';
import Icon from '../../../../components/Section/Icon';
import svg from '../../../../static/img/icon-open-menu.svg';
import { Categories, Actions, Labels } from '../../../../types/gtm';
import { useAuth } from '../../../../hooks/useAuth';
import Action from '../../../../components/Section/Action';

const BoxDownloadData = () => {
  const { user } = useAuth();
  const title = 'Download de dados';
  const describeTitle = 'Faça o download dos dados de sua Conta Globo';
  return (
    <Box title={title} describeTitle={describeTitle}>
      <Content>
        <Action
          onClick={() => {
            window.dataLayer.push({
              event: 'customEventUserInteraction',
              event_category: Categories.Home,
              event_action: Actions.ClickDownloadData,
              event_label: Labels.Home,
              bd_suser_code: user?.globoId,
            });
          }}
          to="/download-data"
          theme="link"
        >
          <p>Download de dados</p>
          <Icon svg={svg} alt="icon-open-menu" />
        </Action>
      </Content>
    </Box>
  );
};

export default BoxDownloadData;
